import { render, staticRenderFns } from "./popupContentBlock.vue?vue&type=template&id=6b29f053&scoped=true&"
import script from "./popupContentBlock.vue?vue&type=script&lang=js&"
export * from "./popupContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./popupContentBlock.vue?vue&type=style&index=0&id=6b29f053&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b29f053",
  null
  
)

export default component.exports